var _path, _rect, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteReportedContentIconDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28 23.9948V10.6615C28 7.71594 25.6122 5.32812 22.6667 5.32812H9.33333C6.38781 5.32812 4 7.71594 4 10.6615V23.9948C4 26.9403 6.38781 29.3281 9.33333 29.3281H22.6667C25.6122 29.3281 28 26.9403 28 23.9948Z",
    fill: "url(#paint0_angular_34522_23902)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.667,
    y: 2.66406,
    width: 10.6667,
    height: 5.33333,
    rx: 2.66667,
    fill: "url(#paint1_angular_34522_23902)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5358 15.1288C19.9264 15.5194 19.9264 16.1525 19.5358 16.543L17.4145 18.6644L19.5358 20.7857C19.9264 21.1763 19.9264 21.8094 19.5358 22.1999C19.1453 22.5905 18.5121 22.5905 18.1216 22.1999L16.0003 20.0786L13.879 22.1999C13.4885 22.5904 12.8553 22.5904 12.4648 22.1999C12.0742 21.8094 12.0742 21.1762 12.4648 20.7857L14.5861 18.6644L12.4648 16.5431C12.0742 16.1526 12.0742 15.5194 12.4648 15.1289C12.8553 14.7384 13.4885 14.7384 13.879 15.1289L16.0003 17.2502L18.1216 15.1288C18.5121 14.7383 19.1453 14.7383 19.5358 15.1288Z",
    fill: "url(#paint2_angular_34522_23902)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_34522_23902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 22.8535) rotate(23.0257) scale(12.7514 51.3577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_34522_23902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0003 6.55859) rotate(11.997) scale(5.33223 12.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_34522_23902",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.0003 20.4272) rotate(23.0258) scale(4.06815 16.385)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927083,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteReportedContentIconDark);
export default __webpack_public_path__ + "static/media/delete-reported-content-icon-dark.991272c9.svg";
export { ForwardRef as ReactComponent };